/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/confirmation`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/confirmation',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Creates a trusted device confirmation for the authenticated user
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * The JWT token of the authenticated user.
     */
    token: string
    /**
     * JWK format public key used to verify device signatures.
     */
    publicKey: {
      [k: string]: any
    }
  }
}

export type Response =
  | {
      /**
       * UUID of the device generated by the API.
       */
      deviceId: string
    }
  | {
      /**
       * Unix timestamp when the next request is allowed. Presence indicates rate limiting.
       */
      nextAllowedTimestamp: number
    }

